export const promotionTypes = [
  { value: 'yougofood', label: 'YouGo Food' },
  { value: 'yougobike', label: 'YouGo Bike' },
  { value: 'yougoship', label: 'YouGo Ship' },
];
export const promotionDiscountTypes = [
  { value: 'fixed_amount', label: 'VNĐ' },
  { value: 'percentage_amount', label: '%' },
];
export const promotionDiscountTargets = [
  { value: 'base_total', label: 'Giá sản phẩm' },
  { value: 'shipping_fee', label: 'Phí vận chuyển' },
];
export const paymentMethods = [
  { value: 'cod', label: 'Thanh toán khi nhận hàng (COD)' },
  { value: 'momo', label: 'Ví Momo' },
  { value: 'shopeepay', label: 'Ví ShopeePay' },
  { value: 'vnpay', label: 'Ví VNPay' },
  { value: 'zalopay', label: 'Ví ZaloPay' },
];
